export enum ErrorName {
  BadRequestError = 'BadRequestError',
  DatasetRunNotFoundError = 'DatasetRunNotFoundError',
  FormValidationError = 'FormInputError',
  GenericNetworkRequestError = 'GenericNetworkRequestError',
  GraphQLGenericError = 'GraphQLGenericError',
  InternalServerError = 'InternalServerError',
  NotFoundError = 'NotFoundError',
  PermissionError = 'PermissionError',
  RateLimitedError = 'RateLimitedError',
  RouteNotFoundError = 'RouteNotFoundError',
  ServiceUnavailableError = 'ServiceUnavailableError',
  UnauthorizedError = 'UnauthorizedError',
  UnknownError = 'UnknownError',
}
